export default "__VITE_ASSET__6bade017__"